module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/icon/desktop/svg/inner_left_fill_44-b0491f.svg";